import { Injectable } from '@angular/core';

import { FeatureToggleService } from '@wdpr/ra-angular-feature-toggle';

@Injectable({
    providedIn: 'root'
})
export class ToggleService {
    private toggles: {};

    constructor(
        private featureToggleService: FeatureToggleService
    ) {
        this.toggles = {};
    }

    getToggle(toggleName: string) {
        return this.toggles[toggleName];
    }

    setToggles(toggles: {}) {
        this.toggles = toggles;
    }

    getToggles() {
        return this.toggles;
    }

    loadToggles(featureSet) {
        return new Promise((resolve) => {
            this.featureToggleService.getToggles(featureSet).subscribe(
                toggles => {
                    this.setToggles(toggles);
                    resolve(toggles);
                },
                () => {
                    resolve({});
                }
            );
        });
    }
}
